import React, { Fragment } from "react";
import { Container } from "../../../components";
import { useI18n } from "../../../lib/i18n/i18n_provider";
import { TextLink } from "../../text_link";
import { Spacer } from "../../spacer";
import { useWeworkPostPurchaseFeatureFlag } from "../../../core/splitio";

const weWorkPostPurchasePopupEN = (
  <>
    <h4
      style={{
        margin: 0,
        fontWeight: "bold",
        fontSize: "16px",
        marginTop: "5px",
      }}
    >
      Looking for refreshments for your meeting?
    </h4>
    <p style={{ margin: 0 }}>
      Discover exclusive promo codes for WeWork guests on Munier’s products.
    </p>
    <TextLink href="https://wework.co.il/munier" external={true}>
      <span style={{ cursor: "pointer" }}>Click here to redeem the offers</span>
    </TextLink>
  </>
);

const weWorkPostPurchasePopupHE = (
  <>
    <h4
      style={{
        margin: 0,
        fontWeight: "bold",
        fontSize: "16px",
        marginTop: "5px",
      }}
    >
      מעוניינים להזמין מגשי אירוח או כיבוד לפגישה?
    </h4>
    <p style={{ margin: 0 }}>
      לחצו על הלינק לקבלת הטבות בלעדיות לאורחי WeWork.
    </p>
    <TextLink href="https://wework.co.il/munier" external={true}>
      <span style={{ cursor: "pointer" }}>למימוש ההטבות לחצו כאן</span>
    </TextLink>
  </>
);

export function PostPurchasePromoBox() {
  const { locale } = useI18n();

  if (!useWeworkPostPurchaseFeatureFlag()) {
    return <></>;
  }

  return (
    <Fragment>
      <Spacer size={16} />
      <div
        className="template-offering-details-base-offering-promo text text-size-md"
        id={"template-offering-details-base-offering-promo"}
      >
        <Container paddingVertical={8} paddingHorizontal={16}>
          {locale.baseLanguageTag === "en"
            ? weWorkPostPurchasePopupEN
            : weWorkPostPurchasePopupHE}
        </Container>
      </div>
    </Fragment>
  );
}
